import { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

export default function Contact() {
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await api.get('/school_contacts');
        setContacts(response.data.data.contacts);
      } catch (err) {
        setError('Failed to load contact information');
      } finally {
        setIsLoading(false);
      }
    };

    fetchContacts();
  }, []);

  const openWhatsApp = (phoneNumber) => {
    const url = `https://wa.me/${phoneNumber.replace(/\+/g, '')}`;
    window.open(url, '_blank');
  };

  if (isLoading) {
    return (
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="animate-pulse">
              <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/4 mb-4"></div>
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mb-2"></div>
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <div className="text-red-600 dark:text-red-400">{error}</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white px-4">
        Contact Us
      </h2>

      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
        <div className="divide-y divide-gray-200 dark:divide-gray-700">
          {contacts.map((contact, index) => (
            <div key={index} className="p-6">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                {contact.department_title[i18n.language]}
              </h3>
              <div className="space-y-3">
                <p className="text-gray-600 dark:text-gray-300">
                  {contact.department_head}
                </p>
                <button
                  onClick={() => openWhatsApp(contact.whatsapp)}
                  className="inline-flex items-center text-sm text-[#25D366] hover:text-[#128C7E] dark:text-[#25D366] dark:hover:text-[#128C7E]"
                >
                  <FaWhatsapp className="h-5 w-5 mr-2" />
                  {contact.whatsapp}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}